(function($) {

	'use strict';

	var init = function() {
        // initReferences($('.flex-references__repeater'))
        // initReferences($('.flex-team__repeater'))
        // initReferences($('.flex-job__repeater'))
        initReferences($('.flex-3-columns__repeater'))
    };
    
    var initReferences = function(selector) {

        $(window).resize(function() {
            if($(window).outerWidth() < 992) {
                selector.removeClass('no-carousel')
                selector.addClass('owl-carousel')
                selector.owlCarousel({
                    loop: false,
                    center: true,
                    items: 1,
                    nav: false,
                    dots: true,
                    autoWidth: true,
                    margin: 30,
                })
            } else {
                selector.trigger('destroy.owl.carousel')
                selector.removeClass('owl-carousel')
                selector.addClass('no-carousel')
            }
        }).resize()

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);
